import { render, staticRenderFns } from "./PwdValidate.vue?vue&type=template&id=653b29b4&scoped=true&"
import script from "./PwdValidate.vue?vue&type=script&lang=ts&"
export * from "./PwdValidate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653b29b4",
  null
  
)

export default component.exports